jQuery(document).ready(function($) {
	
    //open main menu
    $('.nav-menu').click(function(e) {
        e.preventDefault()
        $('.nav-drawer,body').addClass('show')
        
    })

    //turn on menu mobie
    $('.mobile-menu').click(function(e) {
        e.preventDefault()
        $('.mobile-menu-drawer').addClass('show')
        $('body').addClass('show-mb')
       
    })
    
    if($(window).width() < 1024){
    	$('.mobile-menu-drawer ,body').removeClass('show')
        $('body').removeClass('show-mb')
    }
  
  $(window).resize(function(){
  	if($(window).width() < 1024){
    	$('.mobile-menu-drawer ,body').removeClass('show')
        $('body').removeClass('show-mb')
    }
  	})

    //turn off menu mobie
    $('.mobile-menu-drawer .cancel').click(function() {
      	$('body').removeClass('show-mb')
        $('.mobile-menu-drawer, body').removeClass('show')
        document.body.style.backgroundColor = "transparent";
    })



    $('.nav-drawer .cancel').click(function() {
        $('.nav-drawer,body').removeClass('show')
        $('.nav-drawer .navigation .nav-item').removeClass('active')
        document.body.style.backgroundColor = "transparent";
        $('.nav-products-wrapper').hide();
        $('.nav-item').each(function(){
            if($(this).css('display') == 'none'){
                $(this).css('display', 'block');
            }
        })
        // $('.navigation .nav-item.active > a').trigger('click');
    })

    //get product in collection
    function getProduct() {
        $('.nav-drawer .navigation .nav-item > a').click(function(e) {
            e.preventDefault()
			console.log(2)
            var product_list = $(this).next(),

                href = $(this).attr('href'),

                product_class = $(this).next();

            $(this).parent().siblings().removeClass('active')
            if($(this).hasClass('sub-item')){
              $(this).parent().siblings().toggle()
            	if (!$(this).parent().hasClass('active')) {

                $(this).parent().addClass('active')
                
                $(this).next().show()

              } else {


                  $(this).parent().removeClass('active')

                  $(this).next().hide()

                 

              }
            
            }
   

        })
    }

    function getLink(){
      $('.nav-drawer .navigation .nav-item > a').click(function(e) {
            e.preventDefault()
			console.log(1)
            var href = $(this).attr('href')

            $('.nav-hide-link').attr('href', href)[0].click()
      })
    }

    
        getProduct()
    
    
    
     $(document).on("mousewheel DOMMouseScroll", function(event){ 

        w = -event.originalEvent.wheelDelta || event.originalEvent.detail;

        if(w > 0){

          $("body").addClass('reduce-header');

        }else{

          $("body").removeClass('reduce-header');

        }

      })
     if($('.customers-addresses').length || $('.customers-account').length || $('.customers-order').length){
         function handleTouchStart(evt) {
            const firstTouch = getTouches(evt)[0];                                      
            xDown = firstTouch.clientX;                                      
            yDown = firstTouch.clientY;                                      
        }; 
        function handleTouchMove(evt) {
            if ( ! xDown || ! yDown ) {
                return;
            }

            var xUp = evt.touches[0].clientX;                                    
            var yUp = evt.touches[0].clientY;

            var xDiff = xDown - xUp;
            var yDiff = yDown - yUp;

            if ( Math.abs( xDiff ) < Math.abs( yDiff ) ) {/*most significant*/


                if ( yDiff > 0) {

                        $(".site-header").addClass('reduce-header');

                } else if(yDiff < 0){ 

                    $(".site-header").addClass('reduce-header');

                }   


            }
            /* reset values */
            xDown = null;
            yDown = null;                                             
    };
      document.addEventListener('touchstart', handleTouchStart, false);        
      document.addEventListener('touchmove', handleTouchMove, false);
     }
})

